import _ from "underscore";
import $ from "jquery";
import Backbone from "backbone";

export default Backbone.View.extend({

        initialize: function () {
          this.onResize = this.onResize.bind(this);
          this.goTo = this.goTo.bind(this);

            var anchor = this.$el.attr("href"),
                $el = this.$el;
            this.$target = $(anchor);
            this.$sticky = $(this.$el.attr("data-stickyElement")) || false;
            this.motion = this.$el.attr("data-motion") || "swing";

            this.getPosition();

            $(window).on("resize.PubliScrollToWithSticky", _.debounce(this.onResize, 300));
            this.$el.on("click.PubliScrollToWithSticky", this.goTo);
        },

        onResize: function () {
            this.getPosition();
        },

        getPosition: function () {
            var isStickyFixed = this.$sticky && this.$sticky.hasClass("PubliSticky--fixed"),
                baseTop = this.$target["0"].offsetTop;
            
            this.targetTopPosition = baseTop;
            if (!isStickyFixed) {
                this.targetTopPosition -= this.$sticky.outerHeight();
            }

        },

        goTo: function (e) {
            e.preventDefault();
            $("body, html")
                .stop()
                .animate({ scrollTop: this.targetTopPosition }, 600, this.motion);
        }


    });
